import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f619354"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab" }
const _hoisted_2 = { class: "step-number" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "step-description" }, "ENTER PLAYER DETAILS", -1))
const _hoisted_4 = {
  key: 0,
  class: "size-chart"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "font-wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, "CHOOSE YOUR FONT:", -1))
const _hoisted_8 = { class: "font-color-wrapper" }
const _hoisted_9 = { class: "section-header" }
const _hoisted_10 = { class: "color-thumbnail" }
const _hoisted_11 = { class: "color-options" }
const _hoisted_12 = ["onClick", "title"]
const _hoisted_13 = {
  key: 1,
  class: "team-name-wrapper"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, "CHOOSE YOUR TEAM NAME:", -1))
const _hoisted_15 = {
  key: 0,
  class: "team-size-slider-wrapper"
}
const _hoisted_16 = { class: "slider" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"border-top":"2px solid"} }, null, -1))
const _hoisted_18 = { class: "items" }
const _hoisted_19 = { class: "row custom-row-padding" }
const _hoisted_20 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`col-md-3`)
}
const _hoisted_21 = ["for"]
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = ["for"]
const _hoisted_24 = { class: "col-md-3" }
const _hoisted_25 = ["for"]
const _hoisted_26 = { class: "col-md-2 qty" }
const _hoisted_27 = ["for"]
const _hoisted_28 = ["id", "onUpdate:modelValue", "onInput"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-times",
  style: {"font-size":"1rem"}
}, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 0,
  class: "slider-wrapper"
}
const _hoisted_34 = { class: "slider" }
const _hoisted_35 = {
  key: 1,
  class: "slider-wrapper"
}
const _hoisted_36 = { class: "slider" }
const _hoisted_37 = {
  key: 2,
  class: "slider-wrapper"
}
const _hoisted_38 = { class: "slider" }
const _hoisted_39 = {
  key: 3,
  class: "slider-wrapper"
}
const _hoisted_40 = { class: "slider" }
const _hoisted_41 = { class: "slider-wrapper" }
const _hoisted_42 = { class: "slider" }
const _hoisted_43 = {
  key: 4,
  class: "slider-wrapper"
}
const _hoisted_44 = { class: "slider" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_46 = { class: "add-button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.chartRequired ? 'chart-tab-header' : 'tab-header'])
    }, [
      _createElementVNode("span", _hoisted_2, "STEP " + _toDisplayString(_ctx.activeSidebarOption ? _ctx.activeSidebarOption.stepNumber : ""), 1),
      _hoisted_3
    ], 2),
    (_ctx.chartRequired && _ctx.sizingPdfUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("a", {
            href: `${_ctx.sizingPdfUrl}`,
            class: "size-chart-link",
            target: "_blank"
          }, "Size chart guide", 8, _hoisted_5)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(_component_Dropdown, {
        class: "custom-input",
        modelValue: _ctx.fontFamily,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fontFamily) = $event)),
        options: _ctx.fonts,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDetailsChanged())),
        placeholder: "Select your font"
      }, null, 8, ["modelValue", "options"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createTextVNode(" CHOOSE YOUR FONT COLOUR: "),
        _createElementVNode("div", _hoisted_10, [
          _createTextVNode(_toDisplayString(_ctx.fontColor.name) + " ", 1),
          _createElementVNode("div", {
            class: "color-square",
            style: _normalizeStyle({
              'background-color': _ctx.fontColor.value,
            })
          }, null, 4)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorOptions, (color, index) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (_ctx.onFontColorChange(color)),
            key: index,
            class: "color-square",
            style: _normalizeStyle({ 'background-color': color.value }),
            title: color.name
          }, null, 12, _hoisted_12))
        }), 128))
      ])
    ]),
    (_ctx.teamName !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_InputText, {
            id: `team-name`,
            placeholder: "Team name",
            modelValue: _ctx.teamName,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => ((_ctx.teamName) = $event)),
              _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDetailsChanged()))
            ]
          }, null, 8, ["modelValue"]),
          (_ctx.teamNameSizeElementRequired)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("label", null, "TEAM NAME TEXT SIZE: " + _toDisplayString(_ctx.teamNameSize), 1),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Slider, {
                    modelValue: _ctx.teamNameSize,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((_ctx.teamNameSize) = $event)),
                      _cache[5] || (_cache[5] = ($event: any) => (_ctx.onDetailsChanged()))
                    ],
                    max: 100,
                    min: 5
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _hoisted_17,
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_TransitionGroup, {
        name: "list",
        tag: "div"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playersDetails, (el, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "product-item",
              key: el.id
            }, [
              _createElementVNode("div", _hoisted_19, [
                (_ctx.isPlayerNameRequired)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("label", {
                        for: `name${index}`
                      }, "PLAYER NAME", 8, _hoisted_21),
                      _createVNode(_component_InputText, {
                        id: `name${index}`,
                        placeholder: "Player name",
                        modelValue: el.name,
                        "onUpdate:modelValue": [($event: any) => ((el.name) = $event), ($event: any) => (_ctx.onDataChange(index))]
                      }, null, 8, ["id", "modelValue", "onUpdate:modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", {
                    for: `number${index}`
                  }, "NO.", 8, _hoisted_23),
                  _createVNode(_component_InputMask, {
                    id: `number${index}`,
                    "onUpdate:modelValue": [($event: any) => (_ctx.onDataChange(index)), ($event: any) => ((el.number) = $event)],
                    modelValue: el.number,
                    mask: "9?99",
                    placeholder: "999",
                    slotChar: ""
                  }, null, 8, ["id", "onUpdate:modelValue", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", {
                    for: `size${index}`
                  }, "SELECT SIZE", 8, _hoisted_25),
                  _createVNode(_component_Dropdown, {
                    id: `size${index}`,
                    modelValue: el.size,
                    "onUpdate:modelValue": ($event: any) => ((el.size) = $event),
                    onChange: ($event: any) => (_ctx.onDataChange(index)),
                    options: _ctx.sizeOptions,
                    placeholder: "Choose size",
                    optionLabel: "name"
                  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "onChange", "options"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", {
                    for: `quantity-input${index}`
                  }, "QTY", 8, _hoisted_27),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    id: `quantity-input${index}`,
                    "onUpdate:modelValue": ($event: any) => ((el.quantity) = $event),
                    onInput: ($event: any) => (_ctx.quantityChanged(index))
                  }, null, 40, _hoisted_28), [
                    [_vModelText, el.quantity]
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(`col-md-1 view-button`),
                  onClick: ($event: any) => (_ctx.onDataChange(index))
                }, " view ", 8, _hoisted_29),
                (index >= _ctx.minQty)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "col-md-1 remove-button",
                      onClick: ($event: any) => (_ctx.removePlayer(index))
                    }, _hoisted_32, 8, _hoisted_30))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.palyerNameTextSizeRequired)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("label", null, "PLAYER NAME TEXT SIZE: " + _toDisplayString(el.nameSize), 1),
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_Slider, {
                        modelValue: el.nameSize,
                        "onUpdate:modelValue": ($event: any) => ((el.nameSize) = $event),
                        onChange: ($event: any) => (_ctx.onDataChange(index)),
                        max: 100,
                        min: 5
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.nameBackVerticalPositionRequired)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("label", null, "PLAYER NAME VERTICAL POSITION: " + _toDisplayString(el.nameBackVerticalPosition), 1),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_Slider, {
                        modelValue: el.nameBackVerticalPosition,
                        "onUpdate:modelValue": ($event: any) => ((el.nameBackVerticalPosition) = $event),
                        onChange: ($event: any) => (_ctx.onDataChange(index)),
                        max: 100,
                        min: 0
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.playerNumberFrontSizeRequired)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("label", null, "PLAYER NUMBER TEXT SIZE (FRONT): " + _toDisplayString(el.playerNumberFrontSize), 1),
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_Slider, {
                        modelValue: el.playerNumberFrontSize,
                        "onUpdate:modelValue": ($event: any) => ((el.playerNumberFrontSize) = $event),
                        onChange: ($event: any) => (_ctx.onDataChange(index)),
                        max: 100,
                        min: 15
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.playerNumberBackSizeRequired)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("label", null, "PLAYER NUMBER TEXT SIZE (BACK): " + _toDisplayString(el.playerNumberBackSize), 1),
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_Slider, {
                        modelValue: el.playerNumberBackSize,
                        "onUpdate:modelValue": ($event: any) => ((el.playerNumberBackSize) = $event),
                        onChange: ($event: any) => (_ctx.onDataChange(index)),
                        max: 100,
                        min: 5
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("label", null, "PLAYER NUMBER VERTICAL POSITION: " + _toDisplayString(el.playerNumberBackVerticalPosition), 1),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_Slider, {
                    modelValue: el.playerNumberBackVerticalPosition,
                    "onUpdate:modelValue": ($event: any) => ((el.playerNumberBackVerticalPosition) = $event),
                    onChange: ($event: any) => (_ctx.onDataChange(index)),
                    max: 100,
                    min: 5
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                ])
              ]),
              (_ctx.playerNumberHorizontalPositionRequired)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("label", null, "PLAYER NUMBER HORIZONTAL POSITION: " + _toDisplayString(el.playerNumberHorizontalPosition), 1),
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_Slider, {
                        modelValue: el.playerNumberHorizontalPosition,
                        "onUpdate:modelValue": ($event: any) => ((el.playerNumberHorizontalPosition) = $event),
                        onChange: ($event: any) => (_ctx.onDataChange(index)),
                        max: 100,
                        min: 0
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_45
            ]))
          }), 128))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_46, [
        _createVNode(_component_Button, {
          onClick: _ctx.addNewPlayer,
          label: "ADD PLAYER"
        }, null, 8, ["onClick"])
      ])
    ])
  ]))
}